<template>
  <div :class="this.$isPC ? '' : 'sp-product'">
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <!-- sentinel（観測ポイント） -->
    <div
      ref="sentinel"
      :style="{
        height: '1px',
        marginTop: '0px',
      }"
    ></div>
    <div
      ref="stickyHeading"
      class="product-heading product-header-bg"
      :class="[
        productMap[productName].useType == 1 ? 'outgoing' : 'incoming',
        isSticky ? 'sticky' : '',
      ]"
    >
      <div
        class="body"
        :style="{
          marginTop:
            !$isPC && isSticky && logoGroupHeight
              ? `-${logoGroupHeight}px`
              : '',
        }"
      >
        <div
          class="logo-group"
          :style="{
            position: !$isPC && isSticky ? 'absolute' : 'static',
            top: !$isPC && isSticky ? '0' : 'auto',
            left: !$isPC && isSticky ? '0' : 'auto',
            right: !$isPC && isSticky ? '0' : 'auto',
            opacity: isSticky ? '0' : '1',
            pointerEvents: !$isPC && isSticky ? 'none' : 'auto',
            zIndex: !$isPC && isSticky ? '-1' : 'auto',
            transition: 'opacity 0.1s ease',
            overflow: 'hidden',
          }"
        >
          <img v-lazy="'/static/products/' + productName + '/logo.png'" />
          <div>
            <p style="font-size: 12px;">
              {{ productMap[productName].subName }}
            </p>
            <h1 style="font-size: 20px;" class="product-name">
              {{ productMap[productName].name }}
            </h1>
          </div>
        </div>
        <div
          class="product-header-menu"
          :style="!this.$isPC && isSticky ? 'margin-top: 65px;' : ''"
        >
          <a
            v-for="(button, index) in buttons"
            :key="index"
            :href="generateHref(button.type)"
            :class="[
              $route.hash === `#${button.type}` ||
              (!$route.hash && button.type === 'feature')
                ? 'selected'
                : '',
              productMap[productName].useType == 1 ? 'outgoing' : '',
              productMap[productName].useType == 2 ? 'incoming' : '',
            ]"
          >
            <div>{{ button.title }}</div>
          </a>
        </div>
      </div>
    </div>

    <sp-phone-contact
      v-if="!this.$isPC"
      :style="{
        marginBottom: '20px',
        marginTop: !this.$isPC && isSticky ? '85px' : '0',
      }"
    />

    <div v-show="this.$route.params.type == 'feature'" class="feature-body">
      <remote-reply-call v-if="productName == 'remote-reply-call'" />
      <remote-reply-call-pc v-if="productName == 'remote-reply-call-pc'" />
      <reply-call v-else-if="productName == 'reply-call'" />
      <reply-call-pc v-else-if="productName == 'reply-call-pc'" />
      <beyond-ec v-else-if="productName == 'beyond-ec'" />
      <eco-chime v-else-if="productName == 'eco-chime'" />
      <coco-call v-else-if="productName == 'coco-call'" />
      <fact-in-call v-else-if="productName == 'fact-in-call'" />
    </div>

    <div class="other-products">
      <h2 class="other-products-title">他の商品はこちら</h2>
      <div class="product-thumbnails">
        <router-link
          v-for="(product, name) in productMap"
          :key="name"
          v-bind:to="{
            name: 'ProductType',
            params: {
              name: name,
              type: 'feature',
            },
          }"
          class="product-thumbnail"
        >
          <img v-bind:src="product.imagePath" />
        </router-link>
      </div>
    </div>

    <div
      class="product-heading"
      v-bind:class="
        productMap[productName].useType == 1 ? 'outgoing' : 'incoming'
      "
    >
      <div class="body">
        <div class="logo-group">
          <img v-lazy="'/static/products/' + productName + '/logo.png'" />
          <div>
            <p style="font-size: 12px;">
              {{ productMap[productName].subName }}
            </p>
            <p style="font-size: 20px;">{{ productMap[productName].name }}</p>
          </div>
        </div>
        <div class="product-header-menu">
          <a
            v-for="(button, index) in buttons"
            :key="index"
            :href="generateHref(button.type)"
            :class="[
              $route.hash === `#${button.type}` ||
              (!$route.hash && button.type === 'feature')
                ? 'selected'
                : '',
              productMap[productName].useType == 1 ? 'outgoing' : '',
              productMap[productName].useType == 2 ? 'incoming' : '',
            ]"
          >
            <div>{{ button.title }}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RemoteReplyCall from '@/components/modules/products/features/RemoteReplyCall'
import RemoteReplyCallPc from '@/components/modules/products/features/RemoteReplyCallPc'
import ReplyCall from '@/components/modules/products/features/ReplyCall'
import ReplyCallPc from '@/components/modules/products/features/ReplyCallPc'
import BeyondEc from '@/components/modules/products/features/BeyondEc'
import EcoChime from '@/components/modules/products/features/EcoChime'
import CocoCall from '@/components/modules/products/features/CocoCall'
import FactInCall from '@/components/modules/products/features/FactInCall'
import Specs from '@/components/modules/Specs'
import Prices from '@/components/modules/Prices'
import Catalogues from '@/components/modules/Catalogues'
import SpPhoneContact from '@/components/modules/campaign/SpPhoneContact'
import Breadcrumb from '@/components/modules/Breadcrumb'

export default {
  components: {
    RemoteReplyCall,
    RemoteReplyCallPc,
    ReplyCall,
    ReplyCallPc,
    BeyondEc,
    EcoChime,
    CocoCall,
    FactInCall,
    Specs,
    Prices,
    Catalogues,
    SpPhoneContact,
    Breadcrumb,
  },
  title() {
    let pickedName = ''
    switch (this.picked) {
      case 'feature':
        pickedName = '｜B-Call商品紹介（ビーコール）'
        break
      case 'spec':
        pickedName = '｜B-Call商品仕様（ビーコール）'
        break
      case 'price':
        pickedName = '｜B-Call商品価格（ビーコール）'
        break
      case 'catalogue':
        pickedName = '｜B-Call商品カタログ（ビーコール）'
        break
    }
    return this.productMap[this.productName].titleName + pickedName
  },
  meta() {
    return this.productMap[this.productName].meta
  },
  computed: {
    breadcrumbs: function() {
      return {
        data: [
          {
            name: '呼び出しベルのB-Call',
            path: 'https://b-call.jp/',
          },
          {
            name: '商品一覧',
            path: 'https://b-call.jp/products',
          },
          {
            name:
              this.productMap[this.productName].name +
              this.buttons
                .filter(element => element.type === this.picked)[0]
                .title.replace(/\s+/g, ''),
            path:
              'https://b-call.jp/product/' +
              this.productName +
              '/' +
              this.picked,
          },
        ],
      }
    },
  },
  mounted() {
    // logo-groupの高さを取得（SP用）
    this.$nextTick(() => {
      const logoGroup = this.$el.querySelector('.logo-group')
      if (logoGroup && !this.$isPC) {
        this.logoGroupHeight = logoGroup.offsetHeight
      }
    })

    const sentinel = this.$refs.sentinel
    const observer = new IntersectionObserver(
      ([entry]) => {
        const nextSticky = !entry.isIntersecting
        // 状態が変わらないときは無視
        if (this.isSticky === nextSticky) return
        this.isSticky = nextSticky
      },
      {
        root: null,
        rootMargin: this.$isPC ? '0px' : '-10px',
        threshold: 0,
      }
    )
    observer.observe(sentinel)
  },
  data() {
    return {
      buttons: [
        { title: '商品特徴', type: 'feature' },
        { title: '仕 様', type: 'spec' },
        { title: '価 格', type: 'price' },
        { title: 'カタログ', type: 'catalogue' },
      ],
      isSticky: false,
      logoGroupHeight: 0,
      productMap: {
        'remote-reply-call': {
          name: 'リモートリプライコール',
          titleName: '長距離通信リモートリプライコール',
          meta:
            '長距離通信を実現。32文字のメッセージで確実にお知らせ。遠くにいるお客様も確実に呼出し、お客様の待ち時間のストレス解消に役立ちます。大型施設に最適なお客様呼び出しシステムです。',
          subName: 'コードレスパーソナルコールシステム',
          useType: 1,
          imagePath: '/static/products/remote-reply-call/industry.png',
          items: [
            {
              name: '送信機',
              imagePath: '/static/products/remote-reply-call/items/item_01.png',
              spec: {
                型式: 'RR-100',
                サイズ: '214(W) × 151(D) × 43(H) mm',
                重量: '約 860g',
                電源: '100V DC6V アダプタ',
                周波数: '920.60 〜 923.40MHz',
                チャンネル: '15チャンネル（中継機使用時は5チャンネル）',
                空中線電力: '20mW 特定小電力',
              },
              priceName: `送信機
              白(RR-100W) or 黒(RR-100B)`,
              listPrice: 180000,
              regularPrice: 126000,
            },
            {
              name: '受信機',
              imagePath: '/static/products/remote-reply-call/items/item_02.png',
              spec: {
                型式: 'RR-200',
                サイズ: '60（W）×123（D）×13（H）mm',
                重量: '約 115g（電池パック含む）',
                電源: 'リチウムイオン電池 3.8V 1800mAh',
                周波数: '920.60~923.40MHz',
                チャンネル: '15 チャンネル（中継機使用時は 5 チャンネル）',
                連続待ち受け時間: '約 36 時間',
                充電時間: '約 5 時間',
                空中線電力: '20mW 特定小電力',
              },
              priceName: `受信機
              白(RR-200W) or 黒(RR-200B)`,
              listPrice: 65000,
              regularPrice: 45500,
            },
            {
              name: '充電器',
              imagePath: '/static/products/remote-reply-call/items/item_04.png',
              spec: {
                型式: 'RR-300',
                サイズ: '80（W）×305（D）×61（H）mm',
                重量: '約 530g',
                電源: '100V DC6V アダプタ',
                方式: '接点充電',
              },
              priceName: `充電器 10台タイプ（RR-300）`,
              listPrice: 45000,
              regularPrice: 31500,
            },
            {
              name: '中継機',
              imagePath: '/static/products/remote-reply-call/items/item_03.png',
              spec: {
                型式: 'RR-400',
                サイズ: '224.5（W）×177（D）×28（H）mm',
                重量: '約 285g',
                電源: '100V DC6V アダプタ',
                周波数: '920.60~923.40MHz',
                チャンネル: '5 チャンネル',
                空中線電力: '20mW 特定小電力',
              },
              priceName: `中継機（RR-400）`,
              listPrice: 150000,
              regularPrice: 105000,
            },
            {
              name: '管理機',
              imagePath: '/static/products/remote-reply-call/items/item_05.png',
              spec: {
                型式: 'RR-F500',
                サイズ: '224.5（W）×177（D）×28（H）mm',
                重量: '約 285g',
                電源: '100V DC6V アダプタ',
                周波数: '920.60~923.40MHz',
                チャンネル: '15 チャンネル（中継機使用時は 5 チャンネル）',
                空中線電力: '20mW 特定小電力',
              },
              priceName: `管理機（RR-F500）
              送信機用 1台・受信機用 1台`,
              listPrice: 240000,
              regularPrice: 168000,
              openPrice: 240000,
              isCombo: true,
              comment: '※管理機は送信機用1台・受信機用1台で1セット',
            },
          ],
          catalogues: [
            {
              id: 1,
              name: 'リモートリプライコール',
              imagePath:
                '/static/products/remote-reply-call/catalogues/catalogue_01.jpg',
              downloadUri:
                '/static/products/remote-reply-call/catalogues/catalogue_01.pdf',
              pageCount: 4,
              fileType: 'PDF',
              fileSize: '約1.6MB',
            },
            {
              id: 2,
              name: 'リモートリプライコール 取り扱い説明書',
              imagePath:
                '/static/products/remote-reply-call/catalogues/catalogue_02.jpg',
              downloadUri:
                '/static/products/remote-reply-call/catalogues/catalogue_02.pdf',
              pageCount: 20,
              fileType: 'PDF',
              fileSize: '約1.8MB',
            },
          ],
          appDownloadUrl: 'https://echo5555.co.jp/products/remote_appli.php',
        },
        'remote-reply-call-pc': {
          name: 'リモートリプライコールPC',
          titleName: '長距離通信リモートリプライコールPC',
          meta:
            'リモートリプライコールをマウス、タッチパネルの簡単操作で利用することができます。呼び出し状況もわかりやすいアイコン表示で、お知らせ漏れの心配もありません。簡単操作で誰でも安心して使いこなしていただけるシステムです。',
          subName: 'コードレスパーソナルコールシステム',
          useType: 1,
          imagePath: '/static/products/remote-reply-call-pc/industry.png',
          items: [
            {
              name: '送信機',
              imagePath:
                '/static/products/remote-reply-call-pc/items/item_01.png',
              spec: {
                型式: 'RR-100',
                サイズ: '214(W) × 151(D) × 43(H) mm',
                重量: '約 860g',
                電源: '100V DC6V アダプタ',
                周波数: '920.60 〜 923.40MHz',
                チャンネル: '15チャンネル（中継機使用時は5チャンネル）',
                空中線電力: '20mW 特定小電力',
              },
              priceName: `送信機
              白(RR-101W) or 黒(RR-101B)
              アプリ・インストーラー含む`,
              listPrice: 380000,
              regularPrice: 266000,
              comment: '※アプリ・インストーラー付',
            },
            {
              name: '受信機',
              imagePath:
                '/static/products/remote-reply-call-pc/items/item_02.png',
              spec: {
                型式: 'RR-200',
                サイズ: '60（W）×123（D）×13（H）mm',
                重量: '約 115g（電池パック含む）',
                電源: 'リチウムイオン電池 3.8V 1800mAh',
                周波数: '920.60~923.40MHz',
                チャンネル: '15 チャンネル（中継機使用時は 5 チャンネル）',
                連続待ち受け時間: '約 36 時間',
                充電時間: '約 5 時間',
                空中線電力: '20mW 特定小電力',
              },
              priceName: `受信機
              白(RR-200W) or 黒(RR-200B)`,
              listPrice: 65000,
              regularPrice: 45500,
            },
            {
              name: '充電器',
              imagePath:
                '/static/products/remote-reply-call-pc/items/item_04.png',
              spec: {
                型式: 'RR-300',
                サイズ: '80（W）×305（D）×61（H）mm',
                重量: '約 530g',
                電源: '100V DC6V アダプタ',
                方式: '接点充電',
              },
              priceName: `充電器 10台タイプ（RR-300）`,
              listPrice: 45000,
              regularPrice: 31500,
            },
            {
              name: '中継機',
              imagePath:
                '/static/products/remote-reply-call-pc/items/item_03.png',
              spec: {
                型式: 'RR-400',
                サイズ: '224.5（W）×177（D）×28（H）mm',
                重量: '約 285g',
                電源: '100V DC6V アダプタ',
                周波数: '920.60~923.40MHz',
                チャンネル: '5 チャンネル',
                空中線電力: '20mW 特定小電力',
              },
              priceName: `中継機（RR-400）`,
              listPrice: 150000,
              regularPrice: 105000,
            },
          ],
          catalogues: [
            {
              id: 1,
              name: 'リモートリプライコールPC',
              imagePath:
                '/static/products/remote-reply-call-pc/catalogues/catalogue_01.png',
              downloadUri:
                '/static/products/remote-reply-call-pc/catalogues/catalogue_01.pdf',
              pageCount: 2,
              fileType: 'PDF',
              fileSize: '約2.0MB',
            },
            {
              id: 2,
              name: 'リモートリプライコールPC 取り扱い説明書',
              imagePath:
                '/static/products/remote-reply-call-pc/catalogues/catalogue_02.png',
              downloadUri:
                '/static/products/remote-reply-call-pc/catalogues/catalogue_02.pdf',
              pageCount: 12,
              fileType: 'PDF',
              fileSize: '約885KB',
            },
          ],
        },
        'reply-call': {
          name: 'リプライコール',
          titleName: 'お客様呼出しシステムのリプライコール',
          meta:
            '使用場所を選ばず広い敷地でもOK！LED、チャイム音、バイブレーションなどで、お客様をスマートにお呼びします。かんたん操作ですぐに使いこなせるお客様呼び出しシステムです。',
          subName: 'コードレスパーソナルコールシステム',
          useType: 1,
          imagePath: '/static/products/reply-call/industry.png',
          items: [
            {
              name: '送信機',
              imagePath: '/static/products/reply-call/items/item_01.png',
              spec: {
                型式: 'RE-100',
                サイズ: '170（W）×85（D）×40（H）mm',
                重量: '約 200g',
                電源: `100V DV6V アダプター
                単三アルカリ乾電池使用可能（3 本）`,
                周波数: '426.025～426.1375MHz 特定小電力',
                チャンネル: '20 チャンネル',
                到達距離: '約 100m',
                送信: `受信機 99 台
                対応受信確認機能有り
                受信不可通知機能有り`,
                一斉送信: '0 + コール',
                消費電力: '約 3W（ピーク時）',
              },
              priceName: `送信機（RE-100）`,
              listPrice: 40000,
              regularPrice: 28000,
            },
            {
              name: '受信機',
              imagePath: '/static/products/reply-call/items/item_02.png',
              spec: {
                型式: 'RE-200',
                サイズ: '51（W）×116（D）×19（H）mm',
                重量: '100g（電池パック含む）',
                電源: 'リチウムポリマー充電池',
                周波数: '426.025～426.1375MHz 特定小電力',
                チャンネル: '20 チャンネル',
                動作: `受信 LED・7 セグ LED・電子音・
                バイブレーション
                受信音量 2 段切替有り
                送信機番号表示（255 台）可能
                0℃でバイブレーション作動不可`,
                電池残量確認: '赤色 LED バー点滅速度で表示',
                連続待受時間: `約 30 時間以上（圏内時、フル充電時）
                圏外表示機能有り・E（エラー表示）`,
                アンテナ: '内蔵式',
              },
              priceName: `受信機（RE-200）`,
              listPrice: 25000,
              regularPrice: 17500,
            },
            {
              name: '充電器 5台用',
              imagePath: '/static/products/reply-call/items/item_03.png',
              spec: {
                型式: 'RE-305',
                サイズ: '79（W）×165（D）×54（H）mm',
                重量: '約 400g',
                電源: '100V DC6V アダプター',
                充電時間: '約 6 時間',
                充電: `接点充電
                収納部セパレート方式（掃除可能）`,
                消費電力: '約 12W（ピーク時）',
              },
              priceName: `充電器 5 台タイプ（RE-305） `,
              listPrice: 25000,
              regularPrice: 17500,
            },
            {
              name: '充電器 10台用',
              imagePath: '/static/products/reply-call/items/item_04.png',
              spec: {
                型式: 'RE-310',
                サイズ: '79（W）×290（D）×54（H）mm',
                重量: '550g',
                電源: '100V DC6V アダプター',
                充電時間: '約 6 時間',
                充電: `接点充電
                収納部セパレート方式（掃除可能）`,
                消費電力: '約 24W（ピーク時）',
              },
              priceName: `充電器 10 台タイプ（RE-310）`,
              listPrice: 30000,
              regularPrice: 21000,
            },
            {
              name: '中継機',
              imagePath: '/static/products/reply-call/items/item_05.png',
              spec: {
                型式: 'RE-400',
                電源: '100V DC6V アダプター',
                サイズ: '170（W）×85（D）×40（H）mm',
                重量: '約 200g',
                周波数: '426.025～426.1375MHz　特定小電力',
                チャンネル: '20 チャンネル',
                signalStrength: '有り',
                到達距離: '対送信機 約 100m　対受信機 約 100m',
                設定番機: '同一チャンネルエリア 1～8 番機',
                消費電力: '約 3W（ピーク時）',
              },
              priceName: `中継機（RE-400）`,
              listPrice: 30000,
              regularPrice: 21000,
            },
          ],
          catalogues: [
            {
              id: 1,
              name: 'リプライコール',
              imagePath:
                '/static/products/reply-call/catalogues/catalogue_01.jpg',
              downloadUri:
                '/static/products/reply-call/catalogues/catalogue_01.pdf',
              pageCount: 5,
              fileType: 'PDF',
              fileSize: '約1.4MB',
            },
            {
              id: 2,
              name: 'リプライコール 取り扱い説明書',
              imagePath:
                '/static/products/reply-call/catalogues/catalogue_02.jpg',
              downloadUri:
                '/static/products/reply-call/catalogues/catalogue_02.pdf',
              pageCount: 18,
              fileType: 'PDF',
              fileSize: '約5.5MB',
            },
            {
              id: 3,
              name: 'リプライコール 中継機 取り扱い説明書',
              imagePath:
                '/static/products/reply-call/catalogues/catalogue_03.jpg',
              downloadUri:
                '/static/products/reply-call/catalogues/catalogue_03.pdf',
              pageCount: 6,
              fileType: 'PDF',
              fileSize: '約3.0MB',
            },
          ],
        },
        'reply-call-pc': {
          name: 'リプライコールPC',
          titleName: 'PCお客様呼出しシステムのリプライコールPC',
          meta:
            'パソコンやタブレットからリプライコールを操作することができます。登録コードを最大500台の受信機にワンタッチで送信できるので、円滑な業務遂行が可能なお客様呼び出しシステムです。',
          subName: 'コードレスパーソナルコールシステム',
          useType: 1,
          imagePath: '/static/products/reply-call-pc/industry.png',
          items: [
            {
              name: '送信機',
              imagePath: '/static/products/reply-call-pc/items/item_01.png',
              spec: {
                型式: 'RE-101',
                サイズ: '170（W）×85（D）×40（H）mm',
                重量: '約 200g',
                電源: `100V DC6V ダプター
                単三アルカリ乾電池使用可能（3 本）`,
                周波数: '426.025～426.1375MHz 特定小電力',
                チャンネル: '20 チャンネル',
                到達距離: '約 100m',
                送信: `受信機 500 台
                対応受信確認機能有り
                受信不可通知機能有り`,
                一斉送信: '0 + コール',
                消費電力: '約 3W（ピーク時）',
              },
              comment: '※アプリ・USB ケーブル・インストーラー付',
              priceName: `送信操作機（RE-101）
              アプリ・USB ケーブル・インストーラー含`,
              listPrice: 80000,
              regularPrice: 56000,
            },
            {
              name: '受信機',
              imagePath: '/static/products/reply-call-pc/items/item_02.png',
              spec: {
                型式: 'RE-201',
                サイズ: '51（W）×116（D）×19（H）mm',
                重量: '100g（電池パック含む）',
                電源: 'リチウムポリマー充電池',
                周波数: '426.025～426.1375MHz 特定小電力',
                チャンネル: '20 チャンネル',
                動作: `受信 LED・7 セグ LED・ブザー音・
                バイブレーション
                受信音量 2 段切替有り
                送信機番号表示（255 台）可能
                0℃でバイブレーション作動不可`,
                電池残量確認: '赤色 LED バー点滅速度で表示 ',
                連続待受時間: `約 30 時間以上（圏内時、フル充電時）
                圏外表示機能有り・E（エラー表示）`,
                アンテナ: '内蔵式',
              },
              priceName: `携帯受信機（RE-201）`,
              listPrice: 28000,
              regularPrice: 19600,
            },
            {
              name: '充電器 5台用',
              imagePath: '/static/products/reply-call-pc/items/item_03.png',
              spec: {
                型式: 'RE-305',
                サイズ: '79（W）×165（D）×54（H）mm',
                重量: '約 400g',
                電源: '100V DC6V アダプター',
                充電時間: '約 6 時間',
                充電: `接点充電
                収納部セパレート方式（掃除可能）`,
                消費電力: '約 12W（ピーク時）',
              },
              priceName: `充電器 5 台タイプ（RE-305） `,
              listPrice: 25000,
              regularPrice: 17500,
            },
            {
              name: '充電器 10台用',
              imagePath: '/static/products/reply-call-pc/items/item_04.png',
              spec: {
                型式: 'RE-310',
                サイズ: '79（W）×290（D）×54（H）mm',
                重量: '550g',
                電源: '100V DC6V アダプター',
                充電時間: '約 6 時間',
                充電: `接点充電
                収納部セパレート方式（掃除可能）`,
                消費電力: '約 24W（ピーク時）',
              },
              priceName: `充電器 10 台タイプ（RE-310）`,
              listPrice: 30000,
              regularPrice: 21000,
            },
            {
              name: '中継機',
              imagePath: '/static/products/reply-call-pc/items/item_05.png',
              spec: {
                型式: 'RE-400',
                電源: '100V DC6V アダプター',
                サイズ: '170（W）×85（D）×40（H）mm',
                重量: '約 200g',
                周波数: '426.025～426.1375MHz　特定小電力',
                チャンネル: '20 チャンネル',
                signalStrength: '有り',
                到達距離: '対送信機 約 100m　対受信機 約 100m',
                設定番機: '同一チャンネルエリア 1～8 番機',
                消費電力: '約 3W（ピーク時）',
              },
              priceName: `中継機（RE-400）`,
              listPrice: 30000,
              regularPrice: 21000,
            },
          ],
          catalogues: [
            {
              id: 1,
              name: 'リプライコールPC',
              imagePath:
                '/static/products/reply-call-pc/catalogues/catalogue_01.jpg',
              downloadUri:
                '/static/products/reply-call-pc/catalogues/catalogue_01.pdf',
              pageCount: 2,
              fileType: 'PDF',
              fileSize: '約 791KB',
            },
            {
              id: 2,
              name: 'リプライコールPC 取り扱い説明書',
              imagePath:
                '/static/products/reply-call-pc/catalogues/catalogue_02.jpg',
              downloadUri:
                '/static/products/reply-call-pc/catalogues/catalogue_02.pdf',
              pageCount: 16,
              fileType: 'PDF',
              fileSize: '約 6.6MB',
            },
          ],
          appDownloadUrl: 'https://echo5555.co.jp/products/reply_pc_appli.php',
        },
        'beyond-ec': {
          name: 'ビヨンドイーシー',
          titleName: '新・呼び出しシステムBeyond EC（ビヨンド イーシー）',
          meta:
            'Wi-Fiを使うので専用のレシーバーは不要。お手持ちのスマホをそのまま表示機として利用できます。通信無料の特定小電力無線と、Wi-Fiを組み合わせた呼び出しシステムです。',
          subName: '新・呼び出しシステム',
          useType: 2,
          imagePath: '/static/products/beyond-ec/industry.png',
          items: [
            {
              name: '受信機Wi-Fiモデル',
              imagePath: '/static/products/beyond-ec/items/item_01.png',
              spec: {
                品番: `BEC-100`,
                電源入力: `AC100-240V`,
                電源出力: `DC6V`,
                外観: `ABS 樹脂（グレーメタリック）`,
                出力機能: `有線 LAN・無線 LAN、HDMI 出力端子、
                USB ポート`,
                受信周波数: `928.85MHz`,
                受信可能距離: `約 80m（見通し距離）`,
                使用可能周囲温度: `-10℃～ 40℃`,
                サイズ: `138（W）×48（D）×120（H）mm
                （アンテナを含めた高さ 210 ㎜ )`,
                重量: `230g`,
                保証: `1 年`,
              },
              priceName: `受信機Wi-Fiモデル（BEC-100）`,
              listPrice: 182000,
              regularPrice: 182000,
              openPrice: 182000,
            },
            {
              name: '中継機',
              imagePath: '/static/products/beyond-ec/items/item_02.png',
              spec: {
                品番: `BEC-500`,
                電源入力: `AC100-240V`,
                電源出力: `DC6V`,
                外観: `ABS 樹脂（ブラック）`,
                受信周波数: `928.85MHz`,
                送信周波数: `928.85MHz 1mW`,
                受信可能距離: `約 80m（見通し距離）`,
                使用可能周囲温度: `-10℃～ 40℃`,
                サイズ: `100（W）×22（D）×60（H）mm
                （アンテナを含めた高さ 210 ㎜ )`,
                重量: `75g`,
                保証: `1 年`,
              },
              priceName: `中継機（BEC-500)`,
              listPrice: 30000,
              regularPrice: 21000,
              openPrice: 30000,
            },
            {
              name: '電池レス呼出機 角型 1ボタン',
              imagePath: '/static/products/beyond-ec/items/item_03.png',
              spec: {
                品番: `角アイボリー（BEC-211）
                角ブラック（BEC-212）`,
                電源: `電磁誘導式自己発電`,
                外観: `ABS 樹脂`,
                送信周波数: `928.85MHz 1mW`,
                送信可能距離: `約 80m（見通し距離）`,
                使用可能周囲温度: `-10℃～ 40℃`,
                サイズ: `68（W）×22（D）×68（H）mm`,
                重量: `80g`,
                保証: `1 年`,
              },
              priceName: `電池レス呼出機 角型 1 ボタン
              角アイボリー (BEC-211）
              角ブラック (BEC-212）`,
              listPrice: 15000,
              regularPrice: 10500,
              openPrice: 15000,
            },
            {
              name: '電池レス呼出機 丸型 1ボタン',
              imagePath: '/static/products/beyond-ec/items/item_04.png',
              spec: {
                品番: `丸ホワイト（BEC-221）
                丸ブラック（BEC-222）`,
                電源: `電磁誘導式自己発電`,
                外観: `ABS 樹脂`,
                送信周波数: `928.85MHz 1mW`,
                送信可能距離: `約 80m（見通し距離）`,
                使用可能周囲温度: `-10℃～ 40℃`,
                サイズ: `74（W）×30（D）×74（H）mm`,
                重量: `65g`,
                保証: `1 年`,
              },
              priceName: `電池レス呼出機 丸型 1 ボタン
              丸ホワイト (BEC-221）
              丸ブラック (BEC-222）`,
              listPrice: 15000,
              regularPrice: 10500,
              openPrice: 15000,
            },
            {
              name: '電池レス呼出機 ５ボタン',
              imagePath: '/static/products/beyond-ec/items/item_05.png',
              spec: {
                品番: `BEC-251`,
                電源: `電磁誘導式自己発電`,
                外観: `ABS 樹脂`,
                送信周波数: `928.85MHz 1mW`,
                送信可能距離: `約 80m（見通し距離）`,
                使用可能周囲温度: `-10℃～ 40℃`,
                サイズ: `76（W）×28（D）×76（H）mm`,
                重量: `75g`,
                保証: `1 年`,
              },
              priceName: `電池レス呼出機
              5 ボタン（BEC-251）`,
              listPrice: 17000,
              regularPrice: 12000,
              openPrice: 17000,
            },
            {
              name: '電池レス消去機',
              imagePath: '/static/products/beyond-ec/items/item_06.png',
              spec: {
                品番: `BEC-400`,
                電源: `電磁誘導式自己発電`,
                外観: `ABS 樹脂`,
                送信周波数: `928.85MHz 1mW`,
                送信可能距離: `約 80m（見通し距離）`,
                使用可能周囲温度: `-10℃～ 40℃`,
                サイズ: `76（W）×28（D）×76（H）mm`,
                重量: `75g`,
                保証: `1 年`,
              },
              priceName: `電池レス消去機（BEC-400)`,
              listPrice: 18500,
              regularPrice: 13000,
              openPrice: 18500,
            },
            {
              name: '外部入力送信機 ACアダプター付き',
              imagePath: '/static/products/beyond-ec/items/item_07.png',
              spec: {
                品番: `BEC-231`,
                電源: `単三アルカリ電池 ×2 本 /DC3V 専用アダプター`,
                外観: `ABS 樹脂`,
                送信周波数: `928.85MHz 1mW`,
                送信可能距離: `約 80m（見通し距離）`,
                使用可能周囲温度: `0℃～ 40℃`,
                サイズ: `75（W）×36.9（D）×116（H）mm
                ※ホルダー装着時は、
                75.42（W）×42.1（D）×116.42（H）mm）`,
                重量: `165g（単三アルカリ電池 ×2 本含む）
                ※ホルダー装着時は 190g
                （単三アルカリ電池 ×2 本含む）`,
                保証: `1 年`,
              },
              priceName: `外部入力送信機 ACアダプター付き（BEC-231）`,
              listPrice: 18200,
              regularPrice: 18200,
              openPrice: 18200,
            },
          ],
          catalogues: [
            {
              id: 1,
              name: 'ビヨンドイーシー',
              imagePath:
                '/static/products/beyond-ec/catalogues/catalogue_01.png',
              downloadUri:
                '/static/products/beyond-ec/catalogues/catalogue_01.pdf',
              pageCount: 8,
              fileType: 'PDF',
              fileSize: '約 2.4MB',
            },
            {
              id: 2,
              name: 'ビヨンドイーシー 取り扱い説明書',
              imagePath:
                '/static/products/beyond-ec/catalogues/catalogue_02.png',
              downloadUri:
                '/static/products/beyond-ec/catalogues/catalogue_02.pdf',
              pageCount: 24,
              fileType: 'PDF',
              fileSize: '約 3.8MB',
            },
          ],
          appDownloadUrl: 'https://echo5555.co.jp/products/beyond_ec_appli.php',
        },
        'eco-chime': {
          name: 'エコチャイム',
          titleName: '電池レスチャイムのエコチャイム',
          meta:
            '押して発電する革新的な電池レスの呼び出しチャイムシステムです。電池交換不要だからエコ＆トラブル減少を実現。水で洗えるチャイム。高い防水性と耐久性も実現しています。',
          subName: 'コードレスコールシステム',
          useType: 2,
          imagePath: '/static/products/eco-chime/industry.png',
          items: [
            {
              name: '受信機',
              imagePath: '/static/products/eco-chime/items/item_01.png',
              spec: {
                型式: 'EC-110',
                サイズ: '120(W) × 194(D) × 22(H) mm',
                重量: '240g',
                電源: 'DC9V 1.3A',
                受信周波数: '314MHz',
                受信可能距離: '約 60m（見通し距離）',
                使用可能周囲温度: '-10℃～ 40℃',
                受信音: '4 種類',
                音量: '大・中・小・無音',
                保証: '3 年間',
              },
              priceName: `受信機 10 画面（EC-110)`,
              listPrice: 80000,
              regularPrice: 52000,
            },
            {
              name: '受信表示機',
              imagePath: '/static/products/eco-chime/items/item_02.png',
              spec: {
                型式: 'EC-100',
                サイズ: '600（W）×66.3（D）×119（H）mm',
                重量: '1,300g',
                電源: 'AC100～240V',
                受信周波数: '314MHz',
                受信可能距離: '約 100m（見通し距離）',
                使用可能周囲温度: '-10℃～ 40℃',
                受信音: '13 種類',
                音量: '大・中・小・無音',
                受信メモリー: '94 件',
                保証: '3 年間',
              },
              priceName: `受信表示機 LED 表示（EC-100)
              カラー：ブラック、アイボリー`,
              listPrice: 125000,
              regularPrice: 81250,
            },
            {
              name: '電池レス消去機',
              imagePath: '/static/products/eco-chime/items/item_03.png',
              spec: {
                型式: 'EC-400',
                サイズ: '67（W）×117（D）×26（H）mm',
                重量: '115g',
                電源: '電磁誘導式自己発電',
                受信周波数: '314MHz',
                消去: '表示機 5 窓に対応した 5 つのボタン',
                保証: '3 年間',
              },
              priceName: `電池レス消去機 5 窓対応
              （EC-400）`,
              listPrice: 15000,
              regularPrice: 9750,
            },
            {
              name: '中継機',
              imagePath: '/static/products/eco-chime/items/item_04.png',
              spec: {
                型式: 'EC-500',
                サイズ: '120（W）×194（D）×22（H）mm',
                重量: '240g',
                電源: 'DC9V 1.3A',
                受信周波数: '314MHz',
                受信可能距離: '約 60m（見通し距離）',
                使用可能周囲温度: '-10℃～ 40℃',
                保証: '3 年間',
              },
              priceName: `中継機 （EC-500）`,
              listPrice: 28000,
              regularPrice: 18200,
            },
            {
              name: '電池レス送信機角型',
              imagePath: '/static/products/eco-chime/items/item_05.png',
              spec: {
                型式: 'EC-300',
                サイズ: '68（W）×68（D）×22（H）mm',
                重量: '80g',
                電源: '電磁誘導式自己発電',
                カラー: `アイボリー（EC-301）
                ブラック（EC-302）
                パールレッド（EC-303）
                パールブルー（EC-304）
                ウッド（EC-305）`,
                送信周波数: '314MHz',
                保証: '3 年間',
              },
            },
            {
              name: '電池レス送信機角型',
              imagePath: '/static/products/eco-chime/items/item_07.png',
              priceName: `電池レス送信機 角型
              カラー：アイボリー（EC-301）、
              ブラック（EC-302）、
              パールレッド（EC-303）、
              パールブルー（EC-304）`,
              listPrice: 9000,
              regularPrice: 5850,
            },
            {
              name: '電池レス送信機角型',
              imagePath: '/static/products/eco-chime/items/item_08.png',
              priceName: `電池レス送信機 角型
              カラー：ウッド（EC-305）`,
              listPrice: 10000,
              regularPrice: 6500,
            },
            {
              name: '電池レス送信機丸型',
              imagePath: '/static/products/eco-chime/items/item_06.png',
              spec: {
                型式: 'EC-310',
                サイズ: '74（W）×74（D）×30（H）mm',
                重量: '65g',
                電源: '電磁誘導式自己発電',
                カラー: `ホワイト（EC-311）
                ブラック（EC-312）
                大理石調（EC-313）
                ライトウッド（EC-314）
                ウッド（EC-315）`,
                送信周波数: '314MHz',
                保証: '3 年間',
              },
            },
            {
              name: '電池レス送信機丸型',
              imagePath: '/static/products/eco-chime/items/item_09.png',
              priceName: `電池レス送信機 丸型
              カラー：ホワイト（EC-311）、
              ブラック（EC-312）`,
              listPrice: 9000,
              regularPrice: 5850,
            },
            {
              name: '電池レス送信機丸型',
              imagePath: '/static/products/eco-chime/items/item_10.png',
              priceName: `電池レス送信機 丸型
              カラー：大理石調（EC-313）、
              ライトウッド（EC-314）、
              ウッド（EC-315）`,
              listPrice: 10000,
              regularPrice: 6500,
            },
          ],
          catalogues: [
            {
              id: 1,
              name: 'エコチャイム',
              imagePath:
                '/static/products/eco-chime/catalogues/catalogue_01.jpg',
              downloadUri:
                '/static/products/eco-chime/catalogues/catalogue_01.pdf',
              pageCount: 4,
              fileType: 'PDF',
              fileSize: '約 1.6MB',
            },
            {
              id: 2,
              name: 'エコチャイム 取り扱い説明書',
              imagePath:
                '/static/products/eco-chime/catalogues/catalogue_02.jpg',
              downloadUri:
                '/static/products/eco-chime/catalogues/catalogue_02.pdf',
              pageCount: 8,
              fileType: 'PDF',
              fileSize: '約 1.5MB',
            },
          ],
        },
        'coco-call': {
          name: 'コココール',
          titleName: 'コードレス呼出しチャイムのコココール',
          meta:
            '呼び出しを確実に伝えてくれるコードレス呼び出しチャイムシステム。送信機ごとのチャイム音設定など、使い勝手の良さと豊富なデザインが魅力です。',
          subName: 'コードレスコールシステム',
          useType: 2,
          imagePath: '/static/products/coco-call/industry.png',
          items: [
            {
              name: '受信表示機',
              imagePath: '/static/products/coco-call/items/item_01.png',
              spec: {
                型式: 'CC-100B（ブラック）、CC-100S（シルバー）',
                サイズ: '600（W）×66.3（D）×119（H）mm',
                重量: '約 1,320g（コード含む）',
                電源: 'AC100V',
                消費電力: '約 15W',
                受信周波数: '426.025MHz ～（特定小電力）',
                受信方式: '単信方式',
                受信距離: '約 100m（使用環境により変わります）',
                表示方式: '2 桁 5 窓　着信順 1 色表示　設定番号表示',
                チャイム音: '13 種類ロータリー設定',
                音量調節: '10 段階',
                スピーカー出力: '300mW',
                'LED 輝度調節': '10 段階',
                チャンネル: '1 ～ 15 チャンネル',
                電波強度表示機能: '有（設置時に便利）右端窓に表示',
                configDisplay: `右端窓に表示
                （音量・輝度・受信音色が何番目か）`,
                自動消去: `10 秒単位で設定可能
                MAX 990 秒（16 分 30 秒）`,
                メモリ数: '表示を含めて 100 件',
                使用温度: '0℃～ 40℃',
              },
              priceName: `受信表示機
              カラー：ブラック（CC-100B）
              シルバー（CC-100S）`,
              listPrice: 140000,
              regularPrice: 95000,
            },
            {
              name: '消去機＆設定機',
              imagePath: '/static/products/coco-call/items/item_02.png',
              spec: {
                型式: 'CC-400',
                サイズ: '245（W）×80（D）×25（H）mm',
                重量: '約 230g（単三アルカリ乾電池 ×2 本含む）',
                電源: '単三アルカリ電池 ×2 本',
                送受信周波数: '426.025MHz ～（特定小電力）',
                送受信方式: '単信方式',
                送信出力: '1mW',
                送信時動作: '5kHz の電子音（ピッ）',
                設定: '音量・表示輝度・自動消去時間・音色',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              priceName: `消去 & 設定器機 白（CC-400）`,
              listPrice: 30000,
              regularPrice: 21000,
            },
            {
              name: '卓上丸型送信機',
              imagePath: '/static/products/coco-call/items/item_05.png',
              spec: {
                型式: 'F-305',
                サイズ: '80（W）×80（D）×43（H）mm',
                重量: '約 130g（単三アルカリ電池 ×2 本含む）',
                電源: '単三アルカリ電池 ×2 本',
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1 ～ FF',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。
              ※音色設定が出来ます`,
              priceName: `送信機 丸型 1 ボタン（F-305)`,
              listPrice: 12000,
              regularPrice: 8400,
            },
            {
              name: '卓上丸型送信機 ナプキンスタンド型',
              imagePath: '/static/products/coco-call/items/item_06.png',
              spec: {
                型式: 'F-305N',
                サイズ: '99（W）×129（D）×99（H）mm',
                重量: '約 260g（単三アルカリ電池 ×2 本含む）',
                電源: '単三アルカリ電池 ×2 本',
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1 ～ FF',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。
              ※音色設定が出来ます`,
              priceName: `送信機 丸型ナプキン付 1 ボタン
              （F-305N)`,
              listPrice: 15000,
              regularPrice: 10500,
            },
            {
              name: 'スタンダード型送信機',
              imagePath: '/static/products/coco-call/items/item_07.png',
              imageHeight: 300,
              spec: {
                型式: 'F-301',
                サイズ: '85（W）×78（D）×71（H）mm',
                重量: '約 150g（単三アルカリ電池 ×2 本含む）',
                電源: '単三アルカリ電池 ×2 本',
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1～FF',
                表示色設定: '各ボタン 3 色',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。
              ※音色設定が出来ます`,
              priceName: ``,
              listPrice: 0,
              regularPrice: 0,
            },
            {
              name: 'スタンダード型送信機',
              imagePath: '/static/products/coco-call/items/item_16.png',
              priceName: `送信機 スタンダード型 2 ボタン
              （F-301)
              カラー：ブラウンアッシュ、
              メタリック、アイボリー`,
              listPrice: 12000,
              regularPrice: 8400,
            },
            {
              name: 'ナプキンスタンド型送信機',
              imagePath: '/static/products/coco-call/items/item_08.png',
              imageHeight: 300,
              spec: {
                型式: 'F-303',
                サイズ: '99（W）×120（D）×111（H）mm',
                重量: '約 240g（単三アルカリ電池 ×2 本含む）',
                電源: '単三アルカリ電池 ×2 本',
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1～FF',
                表示色設定: '各ボタン 3 色',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。
              ※音色設定が出来ます`,
              priceName: ``,
              listPrice: 0,
              regularPrice: 0,
            },
            {
              name: 'ナプキンスタンド型送信機',
              imagePath: '/static/products/coco-call/items/item_17.png',
              priceName: `送信機 ナプキンスタンド型
              2 ボタン（F-303)
              カラー：ブラウンアッシュ、
              メタリック、アイボリー`,
              listPrice: 15000,
              regularPrice: 10500,
            },
            {
              name: 'カード型送信機',
              imagePath: '/static/products/coco-call/items/item_09.png',
              imageHeight: 300,
              spec: {
                型式: 'F-302',
                サイズ: `55（W）×93（D）×11（H）mm
                （ホルダー装着時は 60(W)x98(D)x15(H)mm）`,
                重量: `約 35g（アルカリボタン電池 ×2 個含む。
                ホルダー装着時は約 55g）`,
                電源: 'アルカリボタン電池 LR44×2 個',
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1～FF',
                表示色設定: '各ボタン 3 色',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。
              ※音色設定が出来ます`,
              priceName: ``,
              listPrice: 0,
              regularPrice: 0,
            },
            {
              name: 'カード型送信機',
              imagePath: '/static/products/coco-call/items/item_18.png',
              priceName: `送信機 カード型ホルダー付
              2 ボタン（F-302)
              カラー：ブラウンアッシュ、
              メタリック、アイボリー`,
              listPrice: 12000,
              regularPrice: 8400,
            },
            {
              name: '携帯受信表示機',
              imagePath: '/static/products/coco-call/items/item_10.png',
              spec: {
                型式: 'F-200',
                サイズ: '51（W）×129（D）×21（H）mm',
                重量: '110g（電池パック含む）',
                電源: '充電バッテリー（リチウムイオンポリマー）',
                送信周波数: '426.025MHz ～（特定小電力）',
                送受信方式: '単信方式',
                '送信出力（消去時）': '1mW',
                送信時動作: '5kHz の電子音（ピッ）',
                表示方式: '2 桁 2 窓　着信順 3 色表示',
                メモリ記憶数: '50 件',
                充電時間: '約 6 時間',
                待受時間: '約 30 時間（使用環境により変わります）',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              priceName: `携帯受信表示機（F-200)
              専用ストラップ・イヤホン付
              カラー：メタリック、ブラック`,
              listPrice: 45000,
              regularPrice: 31500,
            },
            {
              name: '充電器 5台用',
              imagePath: '/static/products/coco-call/items/item_11.png',
              spec: {
                型式: 'F-705',
                サイズ: '79（W）×165（D）×54（H）mm',
                重量: '約 400g',
                電源: 'DC6V 専用アダプター',
                充電時間: '約 6 時間',
                充電方式: '接点充電',
                セパレーツ式: '収納部セパレート方式（掃除可能）',
                消費電力: '約 12W（ピーク時）',
              },
              priceName: `充電器 5 台タイプ（F-705）`,
              listPrice: 25000,
              regularPrice: 17500,
            },
            {
              name: '充電器 10台用',
              imagePath: '/static/products/coco-call/items/item_12.png',
              spec: {
                型式: 'F-710',
                サイズ: '79（W）×290（D）×54（H）mm',
                重量: '約 550g',
                電源: 'DC6V 専用アダプター',
                充電時間: '約 6 時間',
                充電方式: '接点充電',
                セパレーツ式: '収納部セパレート方式（掃除可能）',
                消費電力: '約 24W（ピーク時）',
              },
              priceName: `充電器 10 台タイプ（F-710）`,
              listPrice: 30000,
              regularPrice: 21000,
            },
            {
              name: '中継機',
              imagePath: '/static/products/coco-call/items/item_13.png',
              spec: {
                型式: 'F-500',
                サイズ: `170（W）×85（D）×40（H）mm
                （アンテナ部含まず）`,
                重量: '約 200g',
                電源: 'DC6V 専用アダプター',
                送受信周波数: '426.025MHz ～（特定小電力）',
                送受信方式: '単信方式',
                送信出力: '1mW',
                チャンネル: '1 ～ 15 チャンネル',
                中継機番号設定: '1 ～ 15',
                使用温度: '0℃～ 40℃',
              },
              priceName: `中継機（F-500）`,
              listPrice: 30000,
              regularPrice: 21000,
            },
            {
              name: '受信スピーカー',
              imagePath: '/static/products/coco-call/items/item_14.png',
              spec: {
                型式: 'F-600',
                サイズ: `166（W）×82（D）×42（H）mm
                （アンテナ部含まず）`,
                重量: '約 225g',
                電源: 'DC6V 専用アダプター',
                送受信周波数: '426.025MHz ～（特定小電力）',
                送受信方式: '単信方式',
                受信距離: '約 100m（使用環境により変わります）',
                鳴動回数設定: 'ディップスイッチにて 8 種類',
                音量調節: '回転式ボリューム（無段階）',
                スピーカー出力: '300mW',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              priceName: `受信スピーカー（F-600）`,
              listPrice: 30000,
              regularPrice: 21000,
            },
          ],
          catalogues: [
            {
              id: 1,
              name: 'コココール',
              imagePath:
                '/static/products/coco-call/catalogues/catalogue_01.jpg',
              downloadUri:
                '/static/products/coco-call/catalogues/catalogue_03.pdf',
              pageCount: 2,
              fileType: 'PDF',
              fileSize: '約 2.4MB',
            },
            {
              id: 2,
              name: 'コココール 取り扱い説明書',
              imagePath:
                '/static/products/coco-call/catalogues/catalogue_02.jpg',
              downloadUri:
                '/static/products/coco-call/catalogues/catalogue_05.pdf',
              pageCount: 26,
              fileType: 'PDF',
              fileSize: '約 11MB',
            },
          ],
        },
        'fact-in-call': {
          name: 'ファクトインコール',
          titleName: '工場でも活躍の呼出しチャイム　ファクトインコール',
          meta:
            '工場、飲食店、病院などで活躍する呼出しシステム。携帯受信表示機で急なトラブルや呼び出しにもスピーディーに対応できるコードレス呼出しチャイムです。',
          subName: 'コードレスパーソナルコールシステム',
          useType: 2,
          imagePath: '/static/products/fact-in-call/industry.png',
          items: [
            {
              name: '受信表示機 3色表示',
              imagePath: '/static/products/fact-in-call/items/item_01.png',
              spec: {
                型式: 'F-100',
                サイズ: '550（W）×55（D）×13（H）mm',
                重量: '約 1,350g（コード含む）',
                電源: 'AC100V',
                消費電力: '約 15W',
                受信周波数: '426.025MHz ～（特定小電力）',
                受信方式: '単信方式',
                受信距離: '約 100m（使用環境により変わります）',
                表示方式: `2 桁 5 窓 着信順 3 色表示
                設定番号及び コール残数表示`,
                チャイム音: '13 種類ロータリー設定',
                音量調節: '16 段階',
                スピーカー出力: '300mW',
                'LED 輝度調節': '16 段階',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              priceName: `受信表示機 3 色表示（F-100)`,
              listPrice: 220000,
              regularPrice: 154000,
            },
            {
              name: '消去機＆設定機',
              imagePath: '/static/products/fact-in-call/items/item_02.png',
              spec: {
                型式: 'F-400',
                サイズ: '245（W）×80（D）×25（H）mm',
                重量: '約 230g（単三アルカリ乾電池 ×2 本含む）',
                電源: '単三アルカリ電池 ×2 本',
                送受信周波数: '426.025MHz ～（特定小電力）',
                送受信方式: '単信方式',
                送信出力: '1mW',
                送信時動作: '5kHz の電子音（ピッ）',
                設定: '音量・表示輝度・自動消去時間・音色',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              priceName: `消去 & 設定器機 5 窓対応
              （F-400)`,
              listPrice: 30000,
              regularPrice: 21000,
            },
            {
              name: '携帯受信表示機',
              imagePath: '/static/products/fact-in-call/items/item_03.png',
              spec: {
                型式: 'F-200',
                サイズ: '51（W）×129（D）×21（H）mm',
                重量: '110g（電池パック含む）',
                電源: '充電バッテリー（リチウムイオンポリマー）',
                送信周波数: '426.025MHz ～（特定小電力）',
                送受信方式: '単信方式',
                '送信出力（消去時）': '1mW',
                送信時動作: '5kHz の電子音（ピッ）',
                表示方式: '2 桁 2 窓　着信順 3 色表示',
                メモリ記憶数: '50 件',
                充電時間: '約 6 時間',
                待受時間: '約 30 時間（使用環境により変わります）',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              priceName: `携帯受信表示機（F-200)
              専用ストラップ・イヤホン付
              カラー：メタリック、ブラック`,
              listPrice: 45000,
              regularPrice: 31500,
            },
            {
              name: '充電器 5台用',
              imagePath: '/static/products/fact-in-call/items/item_04.png',
              spec: {
                型式: 'F-705',
                サイズ: '79（W）×165（D）×54（H）mm',
                重量: '約 400g',
                電源: 'DC6V 専用アダプター',
                充電時間: '約 6 時間',
                充電方式: '接点充電',
                セパレーツ式: '収納部セパレート方式（掃除可能）',
                消費電力: '約 12W（ピーク時）',
              },
              priceName: `充電器 5 台タイプ（F-705）`,
              listPrice: 25000,
              regularPrice: 17500,
            },
            {
              name: '充電器 10台用',
              imagePath: '/static/products/fact-in-call/items/item_05.png',
              spec: {
                型式: 'F-710',
                サイズ: '79（W）×290（D）×54（H）mm',
                重量: '約 550g',
                電源: 'DC6V 専用アダプター',
                充電時間: '約 6 時間',
                充電方式: '接点充電',
                セパレーツ式: '収納部セパレート方式（掃除可能）',
                消費電力: '約 24W（ピーク時）',
              },
              priceName: `充電器 10 台タイプ（F-710）`,
              listPrice: 30000,
              regularPrice: 21000,
            },
            {
              name: '無電圧入力送信機',
              imagePath: '/static/products/fact-in-call/items/item_06.png',
              spec: {
                型式: 'F-304',
                サイズ: `75（W）×36.9（D）×116（H）mm
                ホルダー装着時
                75.42（W）×42.1（D）×116.42（H）mm`,
                重量: `約 165g（単三アルカリ電池 ×2 本含む。
                ホルダー装着時は約 190g）`,
                電源: `単三アルカリ電池 ×2 本
                DC3.3V 専用アダプター（別売）`,
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1 ～ FF',
                表示色設定: '色分け可能',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。`,
              priceName: `送信機 無電圧入力型（F-304)
              カラー：グレー`,
              listPrice: 12000,
              regularPrice: 8400,
            },
            {
              name: '電圧入力型送信機（１入力）',
              imagePath: '/static/products/fact-in-call/items/item_06.png',
              spec: {
                型式: 'F-306',
                サイズ: `75（W）×36.9（D）×116（H）mm
                ホルダー装着時
                75.42（W）×42.1（D）×116.42（H）mm`,
                重量: `約 165g（単三アルカリ電池 ×2 本含む。
                ホルダー装着時は約 190g）`,
                電源: `単三アルカリ電池 ×2 本
                DC3.3V 専用アダプター（別売）`,
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1 ～ FF',
                表示色設定: 'ON・OFF 機能のみ',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。`,
              priceName: `送信機 電圧入力型（F-306)
              カラー：グレー`,
              listPrice: 15000,
              regularPrice: 10500,
            },
            {
              name: '電圧入力型送信機（２入力）',
              imagePath: '/static/products/fact-in-call/items/item_06.png',
              spec: {
                型式: 'F-306W',
                サイズ: `75（W）×36.9（D）×116（H）mm
                ホルダー装着時
                75.42（W）×42.1（D）×116.42（H）mm`,
                重量: `約 165g（単三アルカリ電池 ×2 本含む。
                ホルダー装着時は約 190g）`,
                電源: `単三アルカリ電池 ×2 本
                DC3.3V 専用アダプター（別売）`,
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1 ～ FF',
                表示色設定: '色分け可能',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。`,
              priceName: `送信機 電圧入力型 2 ボタン
              （F-306W)
              カラー：グレー`,
              listPrice: 18000,
              regularPrice: 12600,
            },
            {
              name: '卓上丸型送信機',
              imagePath: '/static/products/fact-in-call/items/item_07.png',
              spec: {
                型式: 'F-305',
                サイズ: '80（W）×80（D）×43（H）mm',
                重量: '約 130g（単三アルカリ電池 ×2 本含む）',
                電源: '単三アルカリ電池 ×2 本',
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1 ～ FF',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。
              ※音色設定が出来ます`,
              priceName: `送信機 丸型 1 ボタン（F-305)`,
              listPrice: 12000,
              regularPrice: 8400,
            },
            {
              name: '卓上丸型送信機 ナプキンスタンド型',
              imagePath: '/static/products/fact-in-call/items/item_08.png',
              spec: {
                型式: 'F-305N',
                サイズ: '99（W）×129（D）×99（H）mm',
                重量: '約 260g（単三アルカリ電池 ×2 本含む）',
                電源: '単三アルカリ電池 ×2 本',
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1 ～ FF',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。
              ※音色設定が出来ます`,
              priceName: `送信機 丸型ナプキン付 1 ボタン
              （F-305N)`,
              listPrice: 15000,
              regularPrice: 10500,
            },
            {
              name: 'スタンダード型送信機',
              imagePath: '/static/products/fact-in-call/items/item_09.png',
              imageHeight: 300,
              spec: {
                型式: 'F-301',
                サイズ: '85（W）×78（D）×71（H）mm',
                重量: '約 150g（単三アルカリ電池 ×2 本含む）',
                電源: '単三アルカリ電池 ×2 本',
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1～FF',
                表示色設定: '各ボタン 3 色',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。
              ※音色設定が出来ます`,
              priceName: ``,
              listPrice: 0,
              regularPrice: 0,
            },
            {
              name: 'スタンダード型送信機',
              imagePath: '/static/products/fact-in-call/items/item_14.png',
              priceName: `送信機 スタンダード型 2 ボタン
              （F-301)
              カラー：ブラウンアッシュ、
              メタリック、アイボリー`,
              listPrice: 12000,
              regularPrice: 8400,
            },
            {
              name: 'ナプキンスタンド型送信機',
              imagePath: '/static/products/fact-in-call/items/item_10.png',
              imageHeight: 300,
              spec: {
                型式: 'F-303',
                サイズ: '99（W）×120（D）×111（H）mm',
                重量: '約 240g（単三アルカリ電池 ×2 本含む）',
                電源: '単三アルカリ電池 ×2 本',
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1～FF',
                表示色設定: '各ボタン 3 色',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。
              ※音色設定が出来ます`,
              priceName: ``,
              listPrice: 0,
              regularPrice: 0,
            },
            {
              name: 'ナプキンスタンド型送信機',
              imagePath: '/static/products/fact-in-call/items/item_15.png',
              priceName: `送信機 ナプキンスタンド型
              2 ボタン（F-303)
              カラー：ブラウンアッシュ、
              メタリック、アイボリー`,
              listPrice: 15000,
              regularPrice: 10500,
            },
            {
              name: 'カード型送信機',
              imagePath: '/static/products/fact-in-call/items/item_11.png',
              imageHeight: 300,
              spec: {
                型式: 'F-302',
                サイズ: `55（W）×93（D）×11（H）mm
                （ホルダー装着時は 60(W)x98(D)x15(H)mm）`,
                重量: `約 35g（アルカリボタン電池 ×2 個含む。
                ホルダー装着時は約 55g）`,
                電源: 'アルカリボタン電池 LR44×2 個',
                送信周波数: '426.025MHz ～（特定小電力）',
                充電方式: '単信方式',
                送信出力: '1mW',
                チャイム音設定: 'ディップスイッチにて 13 種類',
                送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
                番号設定: '1～FF',
                表示色設定: '各ボタン 3 色',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              comment: `※電池交換時期お知らせ機能付きです。
              ※音色設定が出来ます`,
              priceName: ``,
              listPrice: 0,
              regularPrice: 0,
            },
            {
              name: 'カード型送信機',
              imagePath: '/static/products/fact-in-call/items/item_16.png',
              priceName: `送信機 カード型ホルダー付
              2 ボタン（F-302)
              カラー：ブラウンアッシュ、
              メタリック、アイボリー`,
              listPrice: 12000,
              regularPrice: 8400,
            },
            {
              name: '中継機',
              imagePath: '/static/products/fact-in-call/items/item_12.png',
              spec: {
                型式: 'F-500',
                サイズ: `170（W）×85（D）×40（H）mm
                （アンテナ部含まず）`,
                重量: '約 200g',
                電源: 'DC6V 専用アダプター',
                送受信周波数: '426.025MHz ～（特定小電力）',
                送受信方式: '単信方式',
                送信出力: '1mW',
                チャンネル: '1 ～ 15 チャンネル',
                中継機番号設定: '1 ～ 15',
                使用温度: '0℃～ 40℃',
              },
              priceName: `中継機（F-500）`,
              listPrice: 30000,
              regularPrice: 21000,
            },
            {
              name: '受信スピーカー',
              imagePath: '/static/products/fact-in-call/items/item_13.png',
              spec: {
                型式: 'F-600',
                サイズ: `166（W）×82（D）×42（H）mm
                （アンテナ部含まず）`,
                重量: '約 225g',
                電源: 'DC6V 専用アダプター',
                送受信周波数: '426.025MHz ～（特定小電力）',
                送受信方式: '単信方式',
                受信距離: '約 100m（使用環境により変わります）',
                鳴動回数設定: 'ディップスイッチにて 8 種類',
                音量調節: '回転式ボリューム（無段階）',
                スピーカー出力: '300mW',
                チャンネル: '1 ～ 15 チャンネル',
                使用温度: '0℃～ 40℃',
              },
              priceName: `受信スピーカー（F-600）`,
              listPrice: 30000,
              regularPrice: 21000,
            },
          ],
          catalogues: [
            {
              id: 1,
              name: 'ファクトインコール工場',
              imagePath:
                '/static/products/fact-in-call/catalogues/catalogue_01.jpg',
              downloadUri:
                '/static/products/fact-in-call/catalogues/catalogue_04.pdf',
              pageCount: 6,
              fileType: 'PDF',
              fileSize: '約 1.5MB',
            },
            {
              id: 2,
              name: 'ファクトインコール汎用',
              imagePath:
                '/static/products/fact-in-call/catalogues/catalogue_02.jpg',
              downloadUri:
                '/static/products/fact-in-call/catalogues/catalogue_02.pdf',
              pageCount: 4,
              fileType: 'PDF',
              fileSize: '約 4MB',
            },
            {
              id: 3,
              name: 'ファクトインコール汎用 取り扱い説明書',
              imagePath:
                '/static/products/fact-in-call/catalogues/catalogue_03.jpg',
              downloadUri:
                '/static/products/fact-in-call/catalogues/catalogue_05.pdf',
              pageCount: 30,
              fileType: 'PDF',
              fileSize: '約 6.7MB',
            },
          ],
          appDownloadUrl: 'https://echo5555.co.jp/products/fact_appli.php',
        },
      },
      productName: this.$route.params.name,
      picked: this.$route.params.type,
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.productName = to.params.name
    this.picked = to.params.type
    next()
  },
  methods: {
    generateHref(type) {
      const baseUrl = `/product/${this.productName}/feature`
      return type === 'feature' ? baseUrl : `${baseUrl}#${type}`
    },
  },
}
</script>

<style scoped>
.product-heading.sticky {
  position: sticky;
  top: 0;
  z-index: 999;
}
@media only screen and (max-width: 600px) {
  .product-heading.sticky {
    top: 97px;
  }
}
.product-header-bg {
  background-size: cover !important;
}
.product-heading {
  width: 100%;
  margin-bottom: 20px;

  background-repeat: no-repeat;
  background-position-y: 25%;
  background-size: cover;
}

.product-heading.outgoing {
  background-image: url('../../assets/scene2.jpg');
}

.product-heading.incoming {
  background-image: url('../../assets/scene3.jpg');
}

.product-heading .body {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  width: 70%;
  height: 100%;
  margin: 20px auto;
}

.sp-product .body {
  width: 100%;
}

.product-heading .body .logo-group {
  display: flex;
}

.sp-product .logo-group {
  width: 90%;
  margin: 0 5%;
}

.product-heading .body .logo-group img {
  display: inline-block;
  align-self: center;

  width: auto;
  height: auto;
  max-height: 60px;
}

.product-heading .body .logo-group div {
  font-weight: bold;

  display: inline-block;
  align-self: center;

  margin-left: 20px;
}

.product-heading .body .logo-group div p {
  margin: 0;
}

.product-name {
  margin: 0;
}

.product-header-menu {
  display: flex;
  align-self: center;
  justify-content: center;
}

.sp-product .product-header-menu {
  width: 100%;
  margin-top: 10px;
}

.product-header-menu a {
  text-decoration: none;
  font-size: 12px;
  font-weight: bold;

  min-width: 50px;
  margin: 0 5px;
  padding: 12px 24px;

  cursor: pointer;
  text-align: center;

  border-radius: 6px;
}

.sp-product .product-header-menu a {
  padding: 12px 12px;
}

.product-header-menu a.outgoing {
  color: rgb(45, 183, 68);
  border: 1px solid rgb(45, 183, 68);
  background-color: rgb(248, 252, 249);
}

.product-header-menu a.selected.outgoing {
  color: rgb(248, 252, 249);
  border: 1px solid rgb(45, 183, 68);
  background-color: rgb(45, 183, 68);
}

.product-header-menu a.incoming {
  color: rgb(16, 106, 203);
  border: 1px solid rgb(16, 106, 203);
  background-color: rgb(248, 251, 255);
}

.product-header-menu a.selected.incoming {
  color: rgb(248, 251, 255);
  border: 1px solid rgb(16, 106, 203);
  background-color: rgb(16, 106, 203);
}

.feature-body {
  width: 100%;
}

.other-products {
  width: 90%;
  max-width: 900px;
}

.other-products .other-products-title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;

  border: 2px solid gray;
  border-radius: 4px;
}

.other-products .product-thumbnails {
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
}

.other-products .product-thumbnails .product-thumbnail {
  width: auto;
  height: 160px;
  margin: 10px 10px;
}

.other-products .product-thumbnails .product-thumbnail img {
  width: auto;
  height: 100%;
}
</style>

<style>
.feature-top {
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
}

.feature-content {
  position: relative;

  margin: 70px 0;
}

.feature-content p {
  font-size: 13px;
  line-height: 26px;

  margin: 0;
}

.feature-content img {
  position: absolute;
  z-index: 1;
  top: -10px;
  right: 10px;
}

.content-header {
  font-size: 22px;
}

.feature-section {
  margin-bottom: 50px;

  text-align: center;
}

.feature-section .header {
  margin: 0 40px;
  padding: 90px 0 20px;
}

.feature-section .header h2 {
  margin: 10px 0;
}

.feature-section .header p {
  font-size: 14px;
  font-weight: bold;

  margin: 0;
}

.feature-section .main-function {
  background-color: rgb(244, 244, 246);
}

.feature-section .main-function .body {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  max-width: 960px;
  margin: 0 auto;
  padding-top: 90px;
}

.feature-section .main-function .body .product-block {
  align-self: flex-start;

  width: 430px;
  margin: 20px 15px;

  text-align: left;
}

.sp-product .feature-section .main-function .body .product-block {
  width: 100%;
}

.feature-section .main-function .body .product-block .product-block-header {
  font-weight: bold;

  padding-bottom: 10px;

  border-bottom: 1px solid rgb(45, 183, 68);
}

.feature-section .main-specification .body {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  max-width: 960px;
  margin: 0 auto;
  padding-top: 140px;
}

.feature-section .main-specification .specification-detail {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  margin: 0 auto;
  padding-top: 140px;
}

.feature-section
  .main-function.blue
  .body
  .product-block
  .product-block-header {
  border-bottom: 1px solid rgb(16, 106, 203);
}

.feature-section
  .main-function
  .body
  .product-block
  .product-block-header
  .product-genre {
  line-height: 30px;

  display: inline-block;

  width: 70px;
  padding: 30px 10px;

  text-align: center;

  color: rgb(45, 183, 68);
  background-color: rgb(177, 230, 184);
}

.feature-section
  .main-function.blue
  .body
  .product-block
  .product-block-header
  .product-genre {
  color: rgb(16, 106, 203);
  background-color: rgb(184, 221, 253);
}

.feature-section
  .main-function
  .body
  .product-block
  .product-block-header
  .product-detail {
  display: inline-block;

  margin-left: 10px;

  vertical-align: middle;
}

.feature-section
  .main-function
  .body
  .product-block
  .product-block-header
  .product-detail
  p {
  line-height: 26px;

  margin: 0;
}

.feature-section .main-function .body .product-block .product-image {
  display: block;

  width: auto;
  height: 200px;
  margin: 20px auto;
}

.sp-product
  .feature-section
  .main-function
  .body
  .product-block
  .product-image {
  max-width: 100%;
  height: 160px;
}

.feature-section .main-function .body .product-block .function {
  padding: 10px 3px;

  border-collapse: collapse;

  border-top: 1px solid rgb(199, 199, 199);
  border-bottom: 1px solid rgb(199, 199, 199);
}

.feature-section .main-function .body .product-block .function + .function {
  border-top: 0;
}

.feature-section .main-function .body .product-block .function .function-title {
  font-weight: bold;

  color: rgb(45, 183, 68);
}

.feature-section
  .main-function.blue
  .body
  .product-block
  .function
  .function-title {
  color: rgb(16, 106, 203);
}

.feature-section
  .main-function
  .body
  .product-block
  .function
  .function-detail {
  font-size: 13px;

  padding-top: 10px;
}

.product_question {
  text-align: center;
}

.product_question .qa-table {
  margin: 0 auto;
  text-align: left;
  width: 60% !important;
}

.column_nav {
  text-align: center;
  padding: 0 2% 50px;
}
.column_nav a {
  transition: 0.3s;
  text-decoration: none;
  color: #0a518d;
}
.column_nav ul {
  display: flex;
  padding: 0;
  justify-content: center;
}
.column_nav h2 {
  margin-bottom: 2%;
}
.column_nav ul li {
  width: 30%;
  margin: 0 1%;
  list-style: none;
}
.column_nav ul li img {
  width: 100%;
  object-fit: fill;
}
.column_nav ul li h3 {
  margin: 0;
  font-size: 90%;
  text-align: left;
}

.feature-section:before {
  content: '""';
  display: block;
  height: 110px;
  margin-top: -110px;
  visibility: hidden;
}

.worries-column {
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  max-width: 960px;
  padding: 0 8px;
  margin: 0 auto;

  @media only screen and (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
}

.worries-column .use-scene-block {
  align-self: flex-start;

  margin: 20px 15px;

  text-align: left;

  flex: 1;
}

.worries-column .use-scene-block img {
  display: block;

  width: 100%;
  max-width: 420px;
  height: auto;
  margin: 10px auto;

  background-color: #eee;
}

.worries-column .use-scene-block p {
  font-size: 12px;
  line-height: 22px;

  margin: 8px 0 0 0;
}

.worries-column .use-scene-block .use-scene-block-header {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.5;
  min-height: calc(1.5em * 3);

  padding-left: 10px;

  border-left: 4px solid rgb(45, 183, 68);

  @media only screen and (max-width: 600px) {
    min-height: auto;
  }
}

@media only screen and (max-width: 600px) {
  .column_nav ul li img {
    object-fit: inherit;
    height: inherit;
  }
  .column_nav ul li h3 {
    margin: 2% 0 4%;
  }
  .feature-section:before {
    height: 190px;
    margin-top: -190px;
  }

  .product_question .qa-table {
    margin: 0 auto;
    text-align: left;
    width: 80% !important;
  }
}

.worry {
  margin-bottom: 7%;
}

@media only screen and (max-width: 600px) {
  .worry {
    margin-bottom: 22%;
  }
}

.column_wrap_cta {
  background: #bfd8f2;
  border-radius: 16px;
  width: 600px;
  margin: 1rem auto 0;
  padding: 0.7rem 0;
}

.column_wrap_cta h3 {
  color: #003287;
  text-align: center;
  margin-bottom: 0;
  letter-spacing: 2px;
  font-size: 1.7rem;
}

.column_wrap_cta p {
  text-align: center;
  color: #000;
  line-height: 1.2;
  margin: 0;
  letter-spacing: 1px;
}

.column_wrap_cta .column_wrap_cta_contact {
  position: relative;
  color: #fff;
  background: #003287;
  width: 80%;
  margin: 1.2rem auto;
  border-radius: 30px;
  padding: 0.6rem;
  font-size: 1.2rem;
  letter-spacing: 3px;
  text-align: center;
  font-weight: bold;
  display: block;
  text-decoration: none;
  transition: opacity 0.3s;
}

.column_wrap_cta .column_wrap_cta_contact:hover {
  opacity: 0.6;
}

.column_wrap_cta .column_wrap_cta_contact::after {
  content: '▶︎';
  position: absolute;
  right: 0.7rem;
}

.column_wrap_cta .column_wrap_cta_tel {
  color: #e60044;
  font-size: 2.2rem;
  font-weight: bold;
  text-align: center;
  padding: 1rem 0;
  position: relative;
  width: fit-content;
  margin: 0 auto;
  letter-spacing: 5px;
  display: block;
  text-decoration: none;
}

.column_wrap_cta .column_wrap_cta_tel svg {
  position: absolute;
  width: 40px;
  left: -3rem;
  top: 0.9rem;
  fill: #e60044;
}

.cta-microcopy {
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
  color: #003287;
  margin: 1.5rem 0 0rem;
  letter-spacing: 1px;
}

@media only screen and (max-width: 600px) {
  .column_wrap_cta {
    width: 88%;
  }

  .column_wrap_cta h3 {
    font-size: 1.2rem;
  }

  .column_wrap_cta p {
    font-size: 0.8rem;
  }

  .column_wrap_cta .column_wrap_cta_contact {
    font-size: 0.8rem;
    width: 90%;
  }

  .column_wrap_cta .column_wrap_cta_tel {
    font-size: 1.5rem;
  }

  .column_wrap_cta .column_wrap_cta_tel svg {
    width: 28px;
    left: -2rem;
    top: 1.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Product.vue